import {
    APPLICATION_SET_HEADER,
    APPLICATION_SET_CURRENT_NAV,
    APPLICATION_SET_LOADER,
} from "../actions/application";

const defaultState = {
    label: "Home",
    currentNav: "Home",
    loaderOpen: false,
};

export function application(state = defaultState, action) {
    switch (action.type) {
        case APPLICATION_SET_HEADER:
            return Object.assign({}, state, {
                label: action.payload.label,
            });
        case APPLICATION_SET_CURRENT_NAV:
            return Object.assign({}, state, {
                currentNav: action.payload.item,
            });
        case APPLICATION_SET_LOADER:
            return Object.assign({}, state, {
                loaderOpen: action.payload.loaderOpen,
            });
        default:
            return state;
    }
}
